import { alpha, useTheme } from '@mui/material/styles'
import type { MessageType } from '../types/chat.types'
import { formatTimestamp } from '../utils/formatMessage'
import { useChat } from '../context/ChatProvider'

const getInitials = (name?: string) => {
  const safeName = name?.trim() || 'Guest'
  return safeName
    .split(' ')
    .map(part => part.charAt(0))
    .join('')
    .toUpperCase()
}

interface MessageItemProps {
  message: MessageType
}

export const MessageItem = ({ message }: MessageItemProps) => {
  const theme = useTheme()
  const {
    participantDisplayName,
    participantAvatarUrl,
    currentUserDisplayName,
  } = useChat()
  const isMine = message.direction === 'outbound'
  const timeLabel = formatTimestamp(message.createdAt)
  const inboundName = participantDisplayName ?? 'Participant'
  const outboundName = currentUserDisplayName ?? 'You'
  const displayName = isMine ? outboundName : inboundName

  return (
    <div
      className={`flex w-full items-end gap-3 ${
        isMine ? 'flex-row-reverse' : ''
      }`}
    >
      {!isMine &&
        (participantAvatarUrl ? (
          <img
            src={participantAvatarUrl}
            alt={inboundName}
            className="object-cover w-10 h-10 shadow-inner rounded-2xl"
          />
        ) : (
          <div
            className="flex items-center justify-center w-10 h-10 text-xs font-semibold shadow-inner rounded-2xl"
            style={{
              backgroundColor: alpha(theme.palette.primary.main, 0.12),
              color: theme.palette.primary.main,
            }}
          >
            {getInitials(inboundName)}
          </div>
        ))}
      <div
        className={`flex max-w-[70%] flex-col gap-2 ${
          isMine ? 'items-end' : 'items-start'
        }`}
      >
        <div
          className="px-4 py-3 text-sm leading-relaxed transition-all shadow w-fit rounded-2xl"
          style={
            isMine
              ? {
                  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                  color: theme.palette.primary.contrastText,
                  boxShadow: `0 12px 30px ${alpha(
                    theme.palette.primary.main,
                    0.25
                  )}`,
                }
              : {
                  backgroundColor: alpha(theme.palette.text.primary, 0.08),
                  color: theme.palette.text.primary,
                }
          }
        >
          {message.body}
        </div>
        <div className="flex items-center gap-2 text-xs tracking-wide uppercase text-slate-400">
          {/* {!isMine && <span className="font-medium">{displayName}</span>} */}
          <span>{timeLabel}</span>
          {isMine && (
            <span className="flex items-center gap-1">
              {/* <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
              {(message.status ?? 'sent').toLowerCase()} */}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
